import { tns } from 'tiny-slider/src/tiny-slider';

function initSlider(e) {
  if (e.dataset.type == 'thumb') {
    const slider = tns({
      loop: false,
      container: e,
      items: 1,
      gutter: 32,
      mouseDrag: true,
      speed: 400,
      swipeAngle: false,
      navAsThumbnails: true,
      navContainer: '.js-nav-thumb',
      prevButton: '.js-nav-prev',
      nextButton: '.js-nav-next',
    });

    slider.goTo(4);

    const thumbs = tns({
      loop: false,
      container: '.js-nav-thumb',
      items: 3,
      gutter: 1,
      mouseDrag: true,
      speed: 400,
      swipeAngle: false,
      nav: true,
      navAsThumbnails: true,
      navContainer: e,
      center: true,
      responsive: {
        768: {
          items: 5,
          edgePadding: 118,
        },
      },
    });
    thumbs.goTo(4);
    slider.events.on('transitionStart', customizedFunction);
  } else if (e.dataset.type == 'video') {
    const videos = tns({
      container: e,
      items: 1,
      loop: false,
      gutter: 9,
      mouseDrag: true,
      speed: 400,
      swipeAngle: false,
      edgePadding: 40,
      responsive: {
        768: {
          edgePadding: 118,
        },
      },
      prevButton: '.js-nav-prev-alternative',
      nextButton: '.js-nav-next-alternative',
    });
    videos.goTo(3);
  } else {
    const slider = tns({
      container: e,
      items: 1.3,
      loop: false,
      mouseDrag: true,
      center: true,
      speed: 400,
      gutter: 16,
      swipeAngle: false,
      navContainer: '.js-nav-dots',
      responsive: {
        1024: {
          disable: true,
        },
      },
    });
  }
}

function customizedFunction(info) {
  info.container.querySelector('.tns-slide-active').click();
}

function init() {
  const sliderElements = document.querySelectorAll('[data-slider]');
  if (sliderElements) {
    sliderElements.forEach(initSlider);
  }
}

export default init();
